import {ActionItem} from "projects/nter-ui-kit/src/lib/webkit/components/common/crud-common-model";

export class AppTableDisplayColumn {
  public colName!: string;
  public displayLabel!: string;
  public exportLabel: string | null = null;
  public visible?: boolean = true;
  public identifier?: boolean = false;
  public displayFunction?: (...val: any) => string;
  public exportFunction?: (...val: any) => string;
  public clickFunction?: (...val: any) => string;
  public clickTooltip?: string | null = null;

  constructor(obj: any) {
    if (obj) {
      Object.assign(this, obj);
    }
  }

  static INSTANCE(object: any): AppTableDisplayColumn {
    let colName = object[object.colName];
    let displayLabel = object[object.displayLabel];
    let exportLabel = object[object.exportLabel] ?? null;
    let visible = object[object.visible] ?? true;
    let identifier = object[object.identifier] ?? false;
    let displayFunction = object[object.displayFunction] ?? null;
    let exportFunction = object[object.exportFunction] ?? null;
    let clickFunction = object[object.clickFunction] ?? null;


    let instance = new AppTableDisplayColumn({
      colName,
      displayLabel,
      exportLabel,
      visible,
      identifier,
      displayFunction,
      exportFunction,
      clickFunction
    });
    Object.assign(instance, object);
    return instance;
  }
}

export interface TableActionItem extends ActionItem {
  icon: string,
  actionDataSource: 'SelectedRow' | "AllRows" | "EmptyRow" | "CustomSupplier" | "None",
  enabled: "Always" | "RowSelected" | "NoRowSelected",
  keepSelectedRowOnClick: boolean,
  supplier?: () => any,
}
